export default (store) => ({
  path : '/drivers/:id(/:tab)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'DriverDetails' */
      './components/DriverDetails'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
